import { Grid } from "@mui/material";
import { useContext, useEffect,useState } from "react"; //FB 7876
import { useNavigate } from "react-router-dom";
import { GetAdminSettingValue, GetFormsData, InsertPPLogs } from "../../../api";  //FB 8478 //FB 8276
import NavBar from "../../../components/Navbar";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ApptContext, InitialApptObj } from "../../../store";
import { AdminSetting } from "../../../api";  //FB  9219

// Update log
// FB  6192   02/06/2023  DK  Dashboard screen
// FB  7469   09/27/2023  SK   Patient Portal - Replace Doctor Direct with License Name , Update logo in Payment Receipt , Change in texts in Home Page
// FB  7876   02/21/2024  GA   Setup Patient Portal for Makovsky
// FB  8423   03/12/2024  GA   Disable portal dashboard options on GNOB based on admin setting
// FB  8478   03/25/2024  DK   cannot read patient data on portal
// FB  9219   08/21/2024  MS   Show/Hide Book appointment button
// FB  8276   09/02/2024  SK   Feature to allow patients to complete certain forms using Portal

export default function Dashboard() {
  const matches = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const { state, dispatch } = useContext(ApptContext);
  let patientName = "User";
  // const matches = useMediaQuery("(min-width:200px)");
  const stylestop = {
    container: {
      border: "1px grey",
      backgroundColor: "white",
      padding: matches == false ? "32px 10px" : "32px 40px",
      height: "auto",
    },
  };
  let userName: any;
  let data = sessionStorage.getItem("user");
  if (data != null) {
    patientName = JSON.parse(data).PatientFirstName.charAt(0).toUpperCase() + JSON.parse(data).PatientFirstName.slice(1);//FB 7469
    userName = JSON.parse(data).Login;
    var isGuardian = JSON.parse(data).IsGuardian;
    var guardian = JSON.parse(data).Guardian;
  }
  async function InsertLogs() {
    InsertPPLogs("Viewing Dashboard", window.location.href, userName, "");
  }

  const handleAppointment = () => {
    state.AppointmentType = "";
    navigate("/user/bookappointment/index");
  }

  //FB 7876 Begin
  const [enableAppointments, setEnableAppointments] = useState(false);
  const [enableMessages, setEnableMessages] = useState(false);
  const [enableTestResults, setEnableTestResults] = useState(false);
  const [enablebilling, setEnableBilling] = useState(false);
  const [showBookAppintmentButton, setshowBookAppintmentButton] = useState(true); //FB 9219

  async function enablePortalOptions(){
    let setting = sessionStorage.getItem("enable_portal_dashboard_options");

    //FB 8478
    if (setting == undefined || setting == null) {
      let value = await GetAdminSettingValue("enable_portal_dashboard_options");
      setting = value;
      sessionStorage.setItem("enable_portal_dashboard_options", value);
    }
    
    if (setting) {
      const values = setting.split(',').map(Number);
      setEnableAppointments(values.includes(1));
      setEnableMessages(values.includes(2));
      setEnableTestResults(values.includes(3));
      setEnableBilling(values.includes(5));
    }
  } 
  //FB 7876 End

  //FB 9219 BEGIN
  async function allowBookAppointment() {
    var data = await AdminSetting("Allow_Portal_Appointment_Booking");
    if (data == "true") {
      setshowBookAppintmentButton(true);
    }
    else
      setshowBookAppintmentButton(false);
  }
  //FB 9219 BEGIN

  //FB 8276 - Begin
  const [formsListCount, setFormsListCount] = useState(false);

  async function GetFormList() {
    var dataEMR = sessionStorage.getItem("user");
    if (dataEMR != null) {
      const user = JSON.parse(dataEMR);
      const data = await GetFormsData(user.EMRID);
      let isFormInProgress = false;

      data.forEach((form: any) => {
        if (form.Status === "AssignToPatient" || form.Status === "Started") {
          isFormInProgress = true;
        }
      });

      if (data.length > 0 && isFormInProgress) {
        setFormsListCount(true);
      }

    }
  }
  //FB 8276 - End
  
  useEffect(() => {
    enablePortalOptions(); //FB 7876
    allowBookAppointment(); //FB 9219
    InsertLogs();
    //FB 8276 - Begin
    GetFormList();
    //FB 8276 - End
  }, []);

  return (
    <div>
      {matches && <NavBar />}
      {!matches && (
        <div
          className="row"
          style={{
            paddingLeft: "25px",
            paddingTop: "16px",
            backgroundColor: "#F5F5F5",
            fontWeight: "bold",
          }}
        >
          Dashboard{" "}
          <hr
            style={{ height: "2px", border: "none", backgroundColor: "black" }}
          ></hr>
        </div>
      )}

      <div className="card" style={stylestart.container}>
        <label
          style={
            matches == false
              ? {
                textAlign: "left",
                color: "black",
                backgroundColor: "#F5F5F5",
                paddingLeft: "16px",
                fontSize: "32px",
                fontWeight: "700",
                lineHeight: "40px",
              }
              : {
                textAlign: "left",
                color: "black",
                backgroundColor: "#F5F5F5",

                paddingLeft: "80px",
                paddingTop: "20px",

                fontSize: "32px",
                fontWeight: "700",
                lineHeight: "40px",
              }
          }
        >
          {isGuardian
            ? "Welcome, " + guardian + " (" + patientName + ")"
            : "Welcome, " + patientName}
        </label>
         
        <div className="card " style={stylesbegin.container}>
          <div
            className="row"
            style={
              matches == false
                ? stylestopmobile.container
                : { padding: "32px 80px", backgroundColor: "#F5F5F5" }
            }
          >
          {/*FB  8423*/}
          <div className="col-sm-6" style={{ paddingBottom: "60px", display: enableAppointments ? "block" : "none" }}>
              <div
                className="card"
                style={
                  matches == false
                    ? {
                      border: "1px grey",
                      backgroundColor: "white",
                      padding: "32px 10px",
                      height: "auto",
                      marginBottom: "16px",
                    }
                    : stylestop.container
                }
              >
                <div className="card-body-name">
                  <span
                    className="card-title"
                    style={{
                      fontFamily: "Inter",
                      fontSize: "24px",
                      fontWeight: 700,
                      lineHeight: "32px",
                      letterSpacing: "0em",
                      paddingTop: "64.5px",
                    }}
                  >
                    Appointments
                  </span>
                  {/* FB 9219 BEGIN */}
                  {showBookAppintmentButton ? "" : (<div>
                    <label
                    className="card-text"
                    style={{
                      fontFamily: "Inter",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                      letterSpacing: "0em",
                      textAlign: "left",
                      paddingBottom: "8px",
                      paddingTop: "16px",
                      display: "block"
                    }}
                  >
                    To View appointments, click on Appointments menu link,
                  </label><br></br></div>)}
                  <br></br>
                  <label
                    className="card-text"
                    style={{
                      fontFamily: "Inter",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                      letterSpacing: "0em",
                      textAlign: "left",
                      paddingBottom: "16px",
                      paddingTop: "16px",
                      display: showBookAppintmentButton ? "block" : "none"
                    }}
                  >
                    To Book an appointment click here,
                  </label>{/* FB 7469 */}
                  {/* FB 7876 */}
                  <button
                    className="btn"
                    onClick={handleAppointment}
                    disabled={!enableAppointments}
                    style={{ display: showBookAppintmentButton ? "block" : "none", backgroundColor: "#13607C", color: "white"}} //FB 9219 BEGIN
                  >
                    Book an appointment
                  </button>
                  {/* FB 9219 END */}
                </div>
              </div>
            </div>
            {/*FB  8423*/}
            <div className="col-sm-6" style={{ paddingBottom: "60px", display: enableMessages ? "block" : "none" }}>
              <div className="card" style={stylestop.container}>
                <div className="card-body-name">
                  <span
                    className="card-title"
                    style={{
                      fontFamily: "Inter",
                      fontSize: "24px",
                      fontWeight: 700,
                      lineHeight: "32px",
                      letterSpacing: "0em",
                      paddingTop: "64.5px",
                    }}
                  >
                    Messages
                  </span>
                  <br></br>
                  <label
                    className="card-text"
                    style={{
                      fontFamily: "Inter",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                      letterSpacing: "0em",
                      textAlign: "left",
                      paddingBottom: "16px",
                      paddingTop: "16px",
                    }}
                  >
                    To view your messages from Provider click here,
                  </label>
                  <br></br>
                  {/* FB 7876 */}
                  {matches && (
                    <button
                      className="btn"
                      style={button.container}
                      onClick={() => navigate("/user/home/Messages")}
                      disabled={!enableMessages}

                    >
                      View messages
                    </button>
                  )}
                  {/* FB 7876 */}
                  {!matches && (
                    <button
                      className="btn"
                      style={button.container}
                      onClick={() => navigate("/user/home/MessageMobileUI")}
                      disabled={!enableMessages}
                    >
                      View messages
                    </button>
                  )}
                </div>
              </div>
            </div>
            {/*FB 8423 Begin */}
            <div className="col-sm-6" style={{ paddingBottom: "60px", display: enableTestResults ? "block" : "none" }}>
              <div
                className="card"
                style={
                  matches == false
                    ? {
                      border: "1px grey",
                      backgroundColor: "white",
                      padding: "32px 10px",
                      height: "auto",
                      marginBottom: "16px",
                    }
                    : stylestop.container
                }
              >
                <div className="card-body-name">
                  <span
                    className="card-title"
                    style={{
                      fontFamily: "Inter",
                      fontSize: "24px",
                      fontWeight: 700,
                      lineHeight: "32px",
                      letterSpacing: "0em",
                      paddingTop: "64.5px",
                    }}
                  >
                    Test results
                  </span>
                  <br></br>
                  <label
                    className="card-text"
                    style={{
                      fontFamily: "Inter",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                      letterSpacing: "0em",
                      textAlign: "left",
                      paddingBottom: "16px",
                      paddingTop: "16px",
                    }}
                  >
                    You have test results from a recent appointment
                  </label>
                  <br></br>
                  {/* FB 7876 */}
                  <button
                    className="btn"
                    style={button.container}
                    onClick={() => navigate("/user/home/testresults")}
                    disabled={!enableTestResults} 

                  >
                    View test results
                  </button>
                </div>
              </div>
            </div>
            {/*FB 8423 */}
            <div className="col-sm-6" style={{ paddingBottom: "60px", display: enablebilling ? "block" : "none" }}>
              <div className="card" style={stylestop.container}>
                <div className="card-body-name">
                  <span
                    className="card-title"
                    style={{
                      fontFamily: "Inter",
                      fontSize: "24px",
                      fontWeight: 700,
                      lineHeight: "32px",
                      letterSpacing: "0em",
                      paddingTop: "64.5px",
                    }}
                  >
                    Billing
                  </span>
                  <br></br>
                  <label
                    className="card-text"
                    style={{
                      fontFamily: "Inter",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                      letterSpacing: "0em",
                      textAlign: "left",
                      paddingBottom: "16px",
                      paddingTop: "16px",
                    }}
                  >
                    To Pay Bills and Print invoice click here,
                  </label>{/* FB 7469 */}
                  {/* FB 7876 */}
                  <br></br>

                  <button
                    className="btn"
                    style={button.container}
                    onClick={() => navigate("/user/home/Billing")}
                    disabled={!enablebilling}

                  >
                    Pay bill
                  </button>
                </div>
              </div>
            </div>
            {/* FB 8276 - Begin */}
             <div className="col-sm-6" style={{ paddingBottom: "60px", display: formsListCount ? "block" : "none" }}>
              <div
                className="card"
                style={
                  matches == false
                    ? {
                      border: "1px grey",
                      backgroundColor: "white",
                      padding: "32px 10px",
                      height: "auto",
                      marginBottom: "16px",
                    }
                    : stylestop.container
                }
              >
                <div className="card-body-name">
                  <span
                    className="card-title"
                    style={{
                      fontFamily: "Inter",
                      fontSize: "24px",
                      fontWeight: 700,
                      lineHeight: "32px",
                      letterSpacing: "0em",
                      paddingTop: "64.5px",
                    }}
                  >
                    Forms Requested by Office
                  </span>
                  <br></br>
                  <label
                    className="card-text"
                    style={{
                      fontFamily: "Inter",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                      letterSpacing: "0em",
                      textAlign: "left",
                      paddingBottom: "16px",
                      paddingTop: "16px",
                    }}
                  >
                    Fill the forms
                  </label>
                  <br></br>
                  <button
                    className="btn"
                    style={button.container}
                    onClick={() => navigate("/user/home/Forms")}
                    disabled={!enableTestResults}

                  >
                    View Forms
                  </button>
                </div>
              </div>
            </div>
            {/* FB 8276 - End */}
          </div>
        </div>
      </div>
    </div>
  );
}

const stylestart = {
  container: {
    border: "1px grey",
    backgroundColor: "#F5F5F5",
    marginBottom: "20px",
  },
};
const stylesbegin = {
  container: {
    border: "1px grey",
    backgroundColor: "#F5F5F5",
  },
};

const stylestopmobile = {
  container: {
    padding: "32px 16px 16px 16px",
    backgroundColor: "#F5F5F5",
  },
};

const stylestoptwo = {
  container: {
    border: "1px grey",
    backgroundColor: "white",
    padding: "32px 40px",
  },
};
const button = {
  container: {
    backgroundColor: "#13607C",
    color: "white",
  },
};
